import React from "react";
import "./App.css";
import "./styles/premium.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { B2BAuthProvider } from "./context/B2BAuthContext";
import { B2BOrderProvider } from "./context/B2BOrderContext";
import ModernHeader from "./components/ModernHeader";
import ModernFooter from "./components/ModernFooter";
import WhatsAppButton from "./components/WhatsAppButton";
import { initializeMockData } from "./utils/mockData";

// Pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import EmailRegisterPage from "./pages/EmailRegisterPage";
import AdminLogin from "./pages/AdminLogin";
import AdminProducts from "./pages/AdminProducts";
import AdminSettings from "./pages/AdminSettings";

// B2B Pages
import B2BLogin from "./pages/b2b/B2BLogin";
import B2BVerify from "./pages/b2b/B2BVerify";
import B2BRegister from "./pages/b2b/B2BRegister";
import B2BDashboard from "./pages/b2b/B2BDashboard";
import B2BOrder from "./pages/b2b/B2BOrder";
import B2BOrderConfirm from "./pages/b2b/B2BOrderConfirm";
import AdminDashboard from "./pages/b2b/AdminDashboard";

// Initialize mock data
initializeMockData();

const Layout = ({ children }) => {
  return (
    <>
      <ModernHeader />
      {children}
      <ModernFooter />
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <B2BAuthProvider>
        <B2BOrderProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                {/* Main Pages with Layout */}
                <Route path="/" element={<Layout><HomePage /></Layout>} />
                <Route path="/products" element={<Layout><ProductsPage /></Layout>} />
                <Route path="/about" element={<Layout><AboutPage /></Layout>} />
                <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
                
                {/* Login/Register Routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register/email" element={<EmailRegisterPage />} />
                
                {/* Admin Routes */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/products" element={<AdminProducts />} />
                <Route path="/admin/settings" element={<AdminSettings />} />
                
                {/* B2B Portal Routes (No Header/Footer) */}
                <Route path="/b2b/login" element={<B2BLogin />} />
                <Route path="/b2b/verify" element={<B2BVerify />} />
                <Route path="/b2b/register" element={<B2BRegister />} />
                <Route path="/b2b/dashboard" element={<B2BDashboard />} />
                <Route path="/b2b/order/:type" element={<B2BOrder />} />
                <Route path="/b2b/order-confirm/:orderId" element={<B2BOrderConfirm />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </BrowserRouter>
          </div>
        </B2BOrderProvider>
      </B2BAuthProvider>
    </LanguageProvider>
  );
}

export default App;